import { TimesheetProjection } from '@sdk/timesheets/types/TimesheetProjection';

import TimesheetEntryBaseRow from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AutomatedTimesheetEntries/TimesheetEntryBaseRow/TimesheetEntryBaseRow';
import timeGreenIcon from '@kiosk/assets/svg/icons/time-green.svg';
import timeGrayIcon from '@kiosk/assets/svg/icons/time-gray.svg';
import AutomatedBreakEntries from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AutomatedTimesheetEntries/AutomatedBreakEntries/AutomatedBreakEntries';
import getClockedInMinutes from '@kiosk/timeClock/utils/getClockedInMinutes';
import { formatTime, getDisplayDuration } from '@kiosk/utils/Utils';
import { getEntryContentTxt } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AutomatedTimesheetEntries/automatedTimesheetEntries.utils';

type Props = {
  projection: TimesheetProjection;
  usTimeFormat: boolean;
  initialAnimationDelay: number;
};

const AutomatedTimesheetEntries = ({ projection, usTimeFormat, initialAnimationDelay }: Props) => {
  const clockInMinutes: number = getClockedInMinutes(projection);
  const displayDuration: string = getDisplayDuration(clockInMinutes);

  return (
    <>
      <TimesheetEntryBaseRow
        label="clock in"
        icon={timeGreenIcon as string}
        contentTxt={getEntryContentTxt({
          time: formatTime(projection.clockIn, usTimeFormat),
          shouldDisplayDuration: !projection.clockOut && !!displayDuration,
          duration: displayDuration
        })}
        delay={initialAnimationDelay}
      />
      <AutomatedBreakEntries
        clockIn={projection.clockIn}
        clockOut={projection.clockOut}
        delay={initialAnimationDelay}
      />
      {!!projection.clockOut && (
        <TimesheetEntryBaseRow
          label="clock out"
          icon={timeGrayIcon as string}
          contentTxt={getEntryContentTxt({
            time: formatTime(projection.clockOut, usTimeFormat),
            shouldDisplayDuration: !!displayDuration,
            duration: displayDuration
          })}
          delay={initialAnimationDelay}
        />
      )}
    </>
  );
};

export default AutomatedTimesheetEntries;
